<h2 mat-dialog-title>What's New</h2>
<mat-dialog-content class="mat-typography">
  <div *ngIf="whatsnewText" [innerHTML]="whatsnewText"></div>
  <div *ngIf="whatsnewText && whatsnewURL"><a class="whatsnew-url" target="_blank" href="{{whatsnewURL}}">Read the full release notes</a></div>
  <div *ngIf="!whatsnewText" class="whatsnew-spinner"><mat-spinner diameter="40"></mat-spinner></div>
</mat-dialog-content>
<mat-dialog-actions *ngIf="whatsnewTitle" align="end">
  <button mat-button cdkFocusInitial (click)="dismiss()">Close</button>
</mat-dialog-actions>
